$(function () {
  const container = $('.photo-container')
  if (!container.length) {
    return
  }

  const fileInput = $('#photo_file_input')
  const overlay = $('.photo-overlay')

  container.hover(
    () => overlay.css('opacity', '1'),
    () => overlay.css('opacity', '0')
  )

  fileInput.on('click', event => event.stopPropagation())

  container.on('click', function (event) {
    if (event.target === fileInput[0]) {
      return
    }

    fileInput.val('')
    fileInput[0].click()
  })

  fileInput.on('change', function (event) {
    const file = event.target.files[0]
    if (!file) {
      return
    }

    const reader = new FileReader()
    reader.onload = function (loaded) {
      const base64 = loaded.target.result
      $('#photo_preview').attr('src', base64)
      $('#photo').val(base64.split(',')[1])
    }
    reader.readAsDataURL(file)
  })
})
